// extracted by mini-css-extract-plugin
module.exports = {"hiddenH1TitleForSeo":"HomePage_hiddenH1TitleForSeo__4sDpo"};